import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["data-category", "onMouseenter", "onClick"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { href: "/special" }
const _hoisted_9 = { href: "/contents/staff-coordinate" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]

import { ref, computed, onMounted } from 'vue';
import { useMQ } from '@/js/lib/helper/media-query';
import { sleep } from '@/js/lib/helper/sleep';
import { categories } from '@/js/data/category';
import HeaderIcons from './HeaderIcons.vue';

interface Series {
  id: string;
  name: string;
  image_header: {
    url: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IHeader',
  props: {
    initialQuery: { default: '' },
    useH1: { type: Boolean },
    isAccount: { type: Boolean },
    isSimple: { type: Boolean },
    seriesList: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;
const { isPc, isSp } = useMQ();
const modalSearchRef = ref<HTMLElement>();
const sethover = ref<number | undefined>(undefined);
const currentModal = ref('');
const currentCategory = ref('');
const query = ref('');
const isSearchOpen = ref(false);
const cats = computed(() => categories());
const subcats = computed(() => (categoryId: number) => categories({ parentCategoryId: categoryId }));
const openModal = (target: string) => {
  document.querySelector('body')?.classList.add('header-menu-open');
  currentModal.value = target;
};
const closeModal = () => {
  document.querySelector('body')?.classList.remove('header-menu-open');
  currentModal.value = '';
  currentCategory.value = '';
};
const onMouseEnterNavigationPC = (target: string) => {
  openModal(target);
};
const onMouseLeaveNavigationPC = () => {
  closeModal();
};
const onClickNavigationSP = (target: string) => {
  openModal(target);
};
const onMouseEnterCategoryPC = (slug: string) => {
  sethover.value = window.setTimeout(() => {
    currentCategory.value = slug;
  }, 300);
};
const onMouseLeaveCategoryPC = () => {
  clearTimeout(sethover.value);
};
const onClickCategory = (slug: string) => {
  currentCategory.value = slug;
};
const onClickCloseModalButton = () => {
  closeModal();
};
const onClickCloseSearchButton = () => {
  document.querySelector('body')?.classList.remove('header-menu-open');
  currentModal.value = '';
  currentCategory.value = '';
  isSearchOpen.value = false;
};
const onClickSearchInputSP = async () => {
  currentModal.value = 'category';
  isSearchOpen.value = true;
  await sleep(100);
  modalSearchRef.value?.focus();
  document.querySelector('body')?.classList.add('header-menu-open');
};
const onSubmitSearch = () => {
  if (query.value) {
    window.dataLayer?.push({
      event: 'search',
      search_term: query.value,
    });
  }
};

onMounted(() => {
  query.value = props.initialQuery;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.header)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.headerMain)
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.useH1 ? 'h1' : 'div'), {
          class: _normalizeClass(_ctx.$style.headerLogo)
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createElementVNode("a", { href: "/" }, [
              _createElementVNode("img", {
                src: "https://cdn.iichi.com/site/images/ui/logo/header-logo.png",
                alt: "iichi",
                width: "87",
                height: "37"
              })
            ], -1)
          ])),
          _: 1,
          __: [11]
        }, 8, ["class"])),
        _cache[15] || (_cache[15] = _createTextVNode()),
        (!_ctx.isSimple)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.isAccount)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.headerSearch)
                  }, [
                    _createElementVNode("form", {
                      action: "/listing",
                      class: _normalizeClass(_ctx.$style.headerSearchForm),
                      onSubmit: onSubmitSearch
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
                        type: "search",
                        name: "q",
                        tabindex: "0",
                        placeholder: "何をお探しですか？",
                        class: _normalizeClass(_ctx.$style.headerSearchQuery),
                        onClick: _cache[1] || (_cache[1] = 
                () => {
                  if (_unref(isSp)) {
                    onClickSearchInputSP();
                  }
                }
              )
                      }, null, 2), [
                        [_vModelText, query.value]
                      ]),
                      _cache[12] || (_cache[12] = _createTextVNode()),
                      _createElementVNode("i", {
                        class: _normalizeClass(['icon-search', _ctx.$style.headerSearchButton])
                      }, null, 2),
                      _cache[13] || (_cache[13] = _createTextVNode()),
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(_ctx.$style.headerSearchSubmit),
                        "aria-label": "検索"
                      }, null, 2)
                    ], 34)
                  ], 2))
                : _createCommentVNode("", true),
              _cache[14] || (_cache[14] = _createTextVNode()),
              _createVNode(HeaderIcons)
            ], 64))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _cache[55] || (_cache[55] = _createTextVNode()),
    (!_ctx.isSimple && !_ctx.isAccount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.navigation)
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass(_ctx.$style.navigationItem),
              onMouseenter: _cache[4] || (_cache[4] = 
          () => {
            if (_unref(isPc)) {
              onMouseEnterNavigationPC('category');
            }
          }
        ),
              onMouseleave: _cache[5] || (_cache[5] = 
          () => {
            if (_unref(isPc)) {
              onMouseLeaveNavigationPC();
            }
          }
        ),
              onClick: _cache[6] || (_cache[6] = 
          () => {
            if (_unref(isSp)) {
              onClickNavigationSP('category');
            }
          }
        )
            }, [
              _cache[30] || (_cache[30] = _createElementVNode("span", null, "カテゴリー", -1)),
              _cache[31] || (_cache[31] = _createTextVNode()),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.modal)
              }, [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.headerSearchFormWrap)
                }, [
                  _createElementVNode("form", {
                    action: "/listing",
                    class: _normalizeClass(_ctx.$style.headerSearchForm)
                  }, [
                    _createElementVNode("input", {
                      ref_key: "modalSearchRef",
                      ref: modalSearchRef,
                      type: "search",
                      name: "q",
                      tabindex: "1",
                      placeholder: "何をお探しですか？",
                      value: query.value,
                      class: _normalizeClass(_ctx.$style.headerSearchQuery)
                    }, null, 10, _hoisted_1),
                    _cache[16] || (_cache[16] = _createTextVNode()),
                    _createElementVNode("i", {
                      class: _normalizeClass(['icon-search', _ctx.$style.headerSearchButton])
                    }, null, 2),
                    _cache[17] || (_cache[17] = _createTextVNode()),
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(_ctx.$style.headerSearchSubmit),
                      "aria-label": "検索"
                    }, null, 2)
                  ], 2),
                  _cache[19] || (_cache[19] = _createTextVNode()),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.modalClose),
                    onClick: _withModifiers(onClickCloseSearchButton, ["stop"])
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "icon-cross1" }, null, -1)
                  ]), 2)
                ], 2), [
                  [_vShow, isSearchOpen.value]
                ]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.headerCategoryTitleWrap)
                }, [
                  (currentCategory.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.subCategoriesClose),
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                () => {
                  currentCategory.value = '';
                }
              , ["stop"]))
                      }, _cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "icon-arrow-left" }, null, -1)
                      ]), 2))
                    : _createCommentVNode("", true),
                  _cache[22] || (_cache[22] = _createTextVNode()),
                  _createElementVNode("p", null, _toDisplayString(currentCategory.value ? cats.value.find((cat) => cat.slug === currentCategory.value)!.name : 'カテゴリーから探す'), 1),
                  _cache[23] || (_cache[23] = _createTextVNode()),
                  (!isSearchOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_ctx.$style.modalClose),
                        onClick: _withModifiers(onClickCloseModalButton, ["stop"])
                      }, _cache[21] || (_cache[21] = [
                        _createElementVNode("i", { class: "icon-cross1" }, null, -1)
                      ]), 2))
                    : _createCommentVNode("", true)
                ], 2),
                _cache[29] || (_cache[29] = _createTextVNode()),
                _createElementVNode("ul", {
                  class: _normalizeClass(_ctx.$style.categories)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cats.value, (cat) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat.slug,
                      class: _normalizeClass([currentCategory.value === cat.slug && _ctx.$style.isActive]),
                      "data-category": cat.slug,
                      onMouseenter: 
                () => {
                  if (_unref(isPc)) {
                    onMouseEnterCategoryPC(cat.slug);
                  }
                }
              ,
                      onMouseleave: _cache[3] || (_cache[3] = 
                () => {
                  if (_unref(isPc)) {
                    onMouseLeaveCategoryPC();
                  }
                }
              ),
                      onClick: _withModifiers(
                () => {
                  onClickCategory(cat.slug);
                }
              , ["stop"])
                    }, [
                      (cat.slug !== 'others')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", null, _toDisplayString(cat.name), 1),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("div", {
                              class: _normalizeClass([_ctx.$style.subCategories, isSearchOpen.value && _ctx.$style.isSearchOpen])
                            }, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: `/category/${cat.slug}`
                                  }, " 全ての" + _toDisplayString(cat.name), 9, _hoisted_3)
                                ]),
                                _cache[24] || (_cache[24] = _createTextVNode()),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcats.value(cat.categoryId), (subcat) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: subcat.slug,
                                    class: _normalizeClass(`category-${subcat.slug}`)
                                  }, [
                                    _createElementVNode("a", {
                                      href: `/category/${cat.slug}/${subcat.slug}`
                                    }, _toDisplayString(subcat.name), 9, _hoisted_4)
                                  ], 2))
                                }), 128))
                              ])
                            ], 2)
                          ], 64))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: `/category/${cat.slug}`
                          }, _toDisplayString(cat.name), 9, _hoisted_5))
                    ], 42, _hoisted_2))
                  }), 128)),
                  _cache[26] || (_cache[26] = _createTextVNode()),
                  _cache[27] || (_cache[27] = _createElementVNode("li", { "data-category": "vintage" }, [
                    _createElementVNode("a", { href: `/listing?vintage=on` }, "アンティーク・ヴィンテージ")
                  ], -1))
                ], 2)
              ], 2), [
                [_vShow, currentModal.value === 'category']
              ])
            ], 34),
            _cache[51] || (_cache[51] = _createTextVNode()),
            _createElementVNode("li", {
              class: _normalizeClass(_ctx.$style.navigationItem),
              onMouseenter: _cache[8] || (_cache[8] = 
          () => {
            if (_unref(isPc)) {
              onMouseEnterNavigationPC('contents');
            }
          }
        ),
              onMouseleave: _cache[9] || (_cache[9] = 
          () => {
            if (_unref(isPc)) {
              onMouseLeaveNavigationPC();
            }
          }
        ),
              onClick: _cache[10] || (_cache[10] = 
          () => {
            if (_unref(isSp)) {
              onClickNavigationSP('category');
            }
          }
        )
            }, [
              _createElementVNode("a", {
                href: "/contents",
                onClick: _cache[7] || (_cache[7] = 
            (e) => {
              if (_unref(isSp)) {
                e.preventDefault();
              }
            }
          )
              }, "読みもの"),
              _cache[47] || (_cache[47] = _createTextVNode()),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.modal)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.headerCategoryTitleWrap)
                }, [
                  _cache[33] || (_cache[33] = _createElementVNode("p", null, "読みもの", -1)),
                  _cache[34] || (_cache[34] = _createTextVNode()),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.modalClose),
                    onClick: _withModifiers(onClickCloseModalButton, ["stop"])
                  }, _cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "icon-cross1" }, null, -1)
                  ]), 2)
                ], 2),
                _cache[46] || (_cache[46] = _createTextVNode()),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.contents)
                }, [
                  _cache[44] || (_cache[44] = _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", { href: "/contents" }, "読みものトップ")
                    ]),
                    _createTextVNode(),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", { href: "/contents/articles" }, "新着記事")
                    ]),
                    _createTextVNode(),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", { href: "/contents/series" }, "シリーズ一覧")
                    ])
                  ], -1)),
                  _cache[45] || (_cache[45] = _createTextVNode()),
                  _createElementVNode("dl", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("dt", null, "ピックアップ", -1)),
                    _cache[40] || (_cache[40] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seriesList.filter((series) => series.id === 'newsletter'), (series) => {
                      return (_openBlock(), _createElementBlock("dd", {
                        key: series.id
                      }, [
                        _createElementVNode("a", {
                          href: `/contents/series/${series.id}`
                        }, [
                          (series.image_header)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `${series.image_header.url}?fm=webp`,
                                alt: "",
                                width: "240",
                                height: "40",
                                decoding: "async",
                                loading: "lazy"
                              }, null, 8, _hoisted_7))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(_ctx.$style.blank)
                              }, null, 2)),
                          _cache[35] || (_cache[35] = _createTextVNode()),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.$style.name)
                          }, _toDisplayString(series.name), 3)
                        ], 8, _hoisted_6)
                      ]))
                    }), 128)),
                    _cache[41] || (_cache[41] = _createTextVNode()),
                    _createElementVNode("dd", null, [
                      _createElementVNode("a", _hoisted_8, [
                        _cache[36] || (_cache[36] = _createElementVNode("img", {
                          src: "https://cdn.iichi.com/site/images/menu/banner/contents/2022/03/featured.jpg",
                          alt: "",
                          width: "240",
                          height: "40",
                          decoding: "async",
                          loading: "lazy"
                        }, null, -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.$style.name)
                        }, "暮らしと手仕事", 2)
                      ])
                    ]),
                    _cache[42] || (_cache[42] = _createTextVNode()),
                    _createElementVNode("dd", null, [
                      _createElementVNode("a", _hoisted_9, [
                        _cache[37] || (_cache[37] = _createElementVNode("img", {
                          src: "https://cdn.iichi.com/content-theme/I3969418/2/65004897e5be8.jpg",
                          alt: "",
                          width: "240",
                          height: "40",
                          decoding: "async",
                          loading: "lazy"
                        }, null, -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.$style.name)
                        }, "スタッフのおすすめコーディネート", 2)
                      ])
                    ]),
                    _cache[43] || (_cache[43] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seriesList.filter((series) => series.id !== 'newsletter'), (series) => {
                      return (_openBlock(), _createElementBlock("dd", {
                        key: series.id
                      }, [
                        _createElementVNode("a", {
                          href: `/contents/series/${series.id}`
                        }, [
                          (series.image_header)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `${series.image_header.url}?fm=webp`,
                                alt: "",
                                width: "240",
                                height: "40",
                                decoding: "async",
                                loading: "lazy"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(_ctx.$style.blank)
                              }, null, 2)),
                          _cache[38] || (_cache[38] = _createTextVNode()),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.$style.name)
                          }, _toDisplayString(series.name), 3)
                        ], 8, _hoisted_10)
                      ]))
                    }), 128))
                  ])
                ], 2)
              ], 2), [
                [_vShow, currentModal.value === 'contents']
              ])
            ], 34),
            _cache[52] || (_cache[52] = _createTextVNode()),
            _createElementVNode("li", {
              class: _normalizeClass(_ctx.$style.navigationItem)
            }, _cache[48] || (_cache[48] = [
              _createElementVNode("a", { href: "/listing?vintage=on" }, "アンティーク・ヴィンテージ", -1)
            ]), 2),
            _cache[53] || (_cache[53] = _createTextVNode()),
            _createElementVNode("li", {
              class: _normalizeClass(_ctx.$style.navigationItem)
            }, _cache[49] || (_cache[49] = [
              _createElementVNode("a", { href: "/featured" }, "人気のカテゴリーと作品", -1)
            ]), 2),
            _cache[54] || (_cache[54] = _createTextVNode()),
            _createElementVNode("li", {
              class: _normalizeClass(_ctx.$style.navigationItem)
            }, _cache[50] || (_cache[50] = [
              _createElementVNode("a", { href: "/event" }, "イベント情報", -1)
            ]), 2)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})